var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 30,
    viewBox: "0 0 29 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7118 30C14.1723 30 13.655 29.8025 13.2735 29.4509C12.8921 29.0993 12.6778 28.6224 12.6778 28.1252L12.6778 6.40389L3.94804 14.4542C3.56612 14.8063 3.04812 15.004 2.508 15.004C1.96787 15.004 1.44988 14.8063 1.06795 14.4542C0.686029 14.1022 0.471466 13.6247 0.471466 13.1269C0.471466 12.629 0.686029 12.1516 1.06795 11.7995L13.2717 0.550789C13.4606 0.376198 13.6851 0.237679 13.9322 0.143164C14.1793 0.0486509 14.4442 1.52111e-07 14.7118 1.55023e-07C14.9793 1.57936e-07 15.2442 0.0486509 15.4913 0.143164C15.7384 0.237679 15.9629 0.376198 16.1518 0.550789L28.3555 11.7995C28.7375 12.1516 28.952 12.629 28.952 13.1269C28.952 13.6247 28.7375 14.1022 28.3555 14.4542C27.9736 14.8063 27.4556 15.004 26.9155 15.004C26.3754 15.004 25.8574 14.8063 25.4755 14.4542L16.7457 6.40389L16.7457 28.1252C16.7457 28.6224 16.5314 29.0993 16.15 29.4509C15.7685 29.8025 15.2512 30 14.7118 30Z",
    fill: "#8FC897"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpArrow);
export default __webpack_public_path__ + "static/media/upArrow.53359ac2b5314e2fd272a8c33e654640.svg";
export { ForwardRef as ReactComponent };